// extracted by mini-css-extract-plugin
export default {"header":"DeleteProductModal_header__h0jQv","wrapper":"DeleteProductModal_wrapper__P1hOr"};